import React from "react";

const PartnersSection = () => {
  const partners = [
    {
      name: "Vulnuris",
      logo: "/images/vulnuris-logo.png",
    },
    {
      name: "Digeco",
      logo: "/images/digeco-logo.png",
    },
    {
      name: "Blue Cloud Softech Solutions Ltd.",
      logo: "/images/bluecloud-softech-logo.png",
    },
    {
      name: "Partner",
      logo: "/images/partner-logo-4.png",
    },
    {
      name: "Accorian",
      logo: "/images/accorian-logo.svg",
    },
    {
      name: "Tribastion",
      logo: "/images/tribastion-logo.svg",
    },
    {
      name: "Talakunchi",
      logo: "/images/talakunchi-logo.png",
    },
    {
      name: "Fluidech",
      logo: "/images/fluidech-logo.png",
    },
    {
      name: "Regent",
      logo: "/images/regent-logo.png",
    },
  ];

  return (
    <section className="py-12 md:py-16 bg-gradient-to-b from-background to-muted/20">
      <div className="container mx-auto px-4 md:px-6">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-foreground">
          Our Partners
        </h2>
        
        {/* Scrolling container */}
        <div className="relative overflow-hidden">
          {/* Gradient overlays for fade effect */}
          <div className="absolute left-0 top-0 bottom-0 w-20 bg-gradient-to-r from-background to-transparent z-10"></div>
          <div className="absolute right-0 top-0 bottom-0 w-20 bg-gradient-to-l from-background to-transparent z-10"></div>
          
          {/* Scrolling content */}
          <div className="flex animate-scroll">
            {/* First set of logos */}
            {partners.map((partner, index) => (
              <div
                key={`partner-1-${index}`}
                className="flex-shrink-0 mx-8 md:mx-12 flex items-center justify-center"
              >
                <img
                  src={partner.logo}
                  alt={partner.name}
                  className="h-16 md:h-20 w-auto object-contain transition-all duration-300 opacity-80 hover:opacity-100"
                />
              </div>
            ))}
            {/* Duplicate set for seamless loop */}
            {partners.map((partner, index) => (
              <div
                key={`partner-2-${index}`}
                className="flex-shrink-0 mx-8 md:mx-12 flex items-center justify-center"
              >
                <img
                  src={partner.logo}
                  alt={partner.name}
                  className="h-16 md:h-20 w-auto object-contain transition-all duration-300 opacity-80 hover:opacity-100"
                />
              </div>
            ))}
          </div>
        </div>
      </div>

      <style>{`
        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }

        .animate-scroll {
          animation: scroll 20s linear infinite;
          width: max-content;
        }

        .animate-scroll:hover {
          animation-play-state: paused;
        }
      `}</style>
    </section>
  );
};

export default PartnersSection;
